const template = `
    <article class="finish">
        <md-content>
            <h2 class="md-display-2 section-title">All done</h2>
                    
            <div layout="column" layout-align="center center">
                <p>You're all set up and ready to go!</p>
                
                <div layout="row">
                    <md-button ng-click="makeChanges($event)"
                               class="md-raised">
                        Make some changes
                    </md-button>
                    
                    <md-button ng-click="finish($event)"
                               class="md-primary md-raised">
                        Continue
                    </md-button>
                </div>
            </div>
            
        </md-content>
    </article>
`;

FinishController.$inject = ['$app', '$http', '$installation', '$scope', '$state', '$window'];

function FinishController($app, $http, $installation, $scope, $state, $window) {
    $scope.finish = finish;
    $scope.makeChanges = makeChanges;

    function makeChanges() {
        $installation.editing = true;
        $state.go('users');
    }

    function finish() {
        $http.post('/install/finished').then(response => {
            const data = response.data;

            if (data.installed) {
                $window.location.assign('/');
            } else {
                $app.errorToast('Something is missing!');
                $installation.state = data.state;
                $state.go($installation.nextStep);
            }
        });
    }
}

export { template, FinishController as controller };
